import HBIcon from "@/components/HBIcon";
import classNames from "classnames";
import { useEffect, useState } from "react";
import styles from "./index.module.less";

/**
 *
 * @param {{
 *  checked: boolean,
 *  onChange?: (checked: boolean) => void,
 *  disabled?: boolean,
 * }} param0
 * @returns
 */
export default function VipCheckbox({ checked, onChange, disabled = false }) {
  const [activeChecked, setActiveChecked] = useState(checked);
  const onClick = () => {
    if (disabled) return;
    setActiveChecked(!activeChecked);
    onChange && onChange(!activeChecked);
  };
  useEffect(() => {
    setActiveChecked(checked);
  }, [checked, disabled]);

  return (
    <>
      <span
        className={classNames(styles.iconWrap, {
          [styles.selected]: activeChecked,
          [styles.disabled]: disabled,
        })}
        onClick={() => onClick()}
      >
        <HBIcon
          type="ic_check"
          style={{ color: "#fff", fontSize: "20px" }}
        ></HBIcon>
      </span>
    </>
  );
}
